import { MyPageAPI } from './screenAPIs/MyPageAPI'
import { ChatAPI } from './screenAPIs/ChatAPI'
import { VerifySMSAPI } from './screenAPIs/VerifySMSAPI'

export const APIs = {
	MyPageAPI: MyPageAPI(),
	ChatAPI: ChatAPI(),
	VerifySMSAPI: VerifySMSAPI(),
}
